import styled from 'styled-components';
export const Label = styled.span `
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${({ theme }) => theme.colors.grey13};
  padding-bottom: 0.25rem;
  display: block;
`;
